export function timeSince(dateString) {
  if (!dateString) return "Unknown time"; // Prevent crashing on undefined

  const now = Date.now();
  const utcString = dateString.replace(' ', 'T') + 'Z';
  const past = new Date(utcString).getTime();

  const seconds = Math.floor((now - past) / 1000);
  const intervals = {
    year:   365 * 24 * 60 * 60,
    month:  30 * 24 * 60 * 60,
    day:    24 * 60 * 60,
    hour:   60 * 60,
    minute: 60,
    second: 1,
  };

  for (const [unit, secInUnit] of Object.entries(intervals)) {
    const count = Math.floor(seconds / secInUnit);
    if (count >= 1) return `${count} ${unit}${count > 1 ? 's' : ''} ago`;
  }
  return 'just now';
}

/**
 * Formats a date/time as relative time in the format "X hrs ago" or "Y day, Z hours ago"
 * @param {string|Date|number} dateInput - Date string, Date object, or timestamp
 * @returns {string} Formatted relative time string
 */
export function formatTimeAgo(dateInput) {
  if (!dateInput) return "";
  
  const now = Date.now();
  let past;
  
  if (typeof dateInput === 'string') {
    // Handle ISO string or date string
    past = new Date(dateInput).getTime();
  } else if (dateInput instanceof Date) {
    past = dateInput.getTime();
  } else if (typeof dateInput === 'number') {
    past = dateInput;
  } else {
    return "";
  }
  
  if (isNaN(past)) return "";
  
  const seconds = Math.floor((now - past) / 1000);
  
  if (seconds < 0) return "in the future";
  if (seconds < 60) return "just now";
  
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min${minutes > 1 ? 's' : ''} ago`;
  
  const hours = Math.floor(seconds / 3600);
  if (hours < 24) return `${hours} ${hours === 1 ? 'hr' : 'hrs'} ago`;
  
  const days = Math.floor(seconds / 86400);
  const remainingHours = Math.floor((seconds % 86400) / 3600);
  
  if (days === 1 && remainingHours === 0) {
    return "1 day ago";
  } else if (days === 1) {
    return `1 day, ${remainingHours} ${remainingHours === 1 ? 'hour' : 'hours'} ago`;
  } else if (remainingHours === 0) {
    return `${days} days ago`;
  } else {
    return `${days} day${days > 1 ? 's' : ''}, ${remainingHours} ${remainingHours === 1 ? 'hour' : 'hours'} ago`;
  }
}